export default __webpack_public_path__ + "static/media/united-kingdom.78000adf.svg";